import { Modal, Form, Select, Button, message, Alert, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import appConfig from "../../../../config/config.json";
import AppInput from "../../../common/AppInput";
import { find, map } from "lodash";
import moment from "moment";
import budgetThunks from "../../../../config/thunks/finance/budgets/budgets.thunks";

const { Option } = Select;
const AddRequsitionMemo = ({ visible, handleAddRecord, handleCloseModal }) => {
  const {
    addRequisitionMemosSuccess,
    addRequisitionMemosLoading,
    addRequisitionMemosError,
    addRequisitionMemosMessage,
    requisitionMemos,
  } = useSelector((state) => state.requisitionMemoState);
  const { approvedBudget, approvedBudgetLoading } = useSelector(
    (state) => state.budgetState
  );
  const { projectsDetails, projectsDetailsLoading, projectsDetailsSuccess } =
    useSelector((state) => state.projectsState);
  const dispatch = useDispatch();
  const [showConceptNotes, setShowConceptNotes] = useState(false);
  const closeModal = () => handleCloseModal(false);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    if (!projectsDetailsLoading && projectsDetailsSuccess) {
      values.created_at = new Date();
      values.project = projectsDetails.id;
      values.budget = projectsDetails.projectBudget;
    } else if (!projectsDetailsSuccess)
      message.error(
        "There seems to be an error loading meta data please refresh the page to reload it"
      );
    else if (projectsDetailsLoading)
      message.info("Loading  meta data please hold on for abit then try again");
    handleAddRecord(values, requisitionMemos);
  };
  // Fetch approved budget when modal opens
  useEffect(() => {
    if (visible && projectsDetails?.projectBudget) {
      dispatch(budgetThunks.getApprovedBudget(projectsDetails.projectBudget));
    }
  }, [visible, projectsDetails?.projectBudget, dispatch]);

  useEffect(() => {
    if (addRequisitionMemosSuccess && addRequisitionMemosMessage) {
      message.success(addRequisitionMemosMessage);
      form.resetFields();
    }
  }, [addRequisitionMemosSuccess, addRequisitionMemosMessage, form]);

  const budgetLineId = Form.useWatch("budget_line", form);

  useEffect(() => {
    const budgetLine = find(approvedBudget, {
      id: budgetLineId,
    });

    setShowConceptNotes(budgetLine?.requires_concept_note || false);
  }, [budgetLineId, approvedBudget]);
  return (
    <div>
      <Modal
        title="CREATE REQUISITION FORM"
        onCancel={closeModal}
        footer={null}
        open={visible}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          form={form}
          onFinish={onFinish}
        >
          {!addRequisitionMemosSuccess && addRequisitionMemosError && (
            <Alert
              className="m-2"
              showIcon
              type="error"
              message={addRequisitionMemosError}
            />
          )}
          <Form.Item
            name="budget_line"
            label="Budget Line"
            rules={[{ required: true, message: "Please select a budget line" }]}
          >
            <Select
              defaultValue=""
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              loading={approvedBudgetLoading}
              allowClear
              placeholder={
                approvedBudgetLoading
                  ? "Loading budget lines..."
                  : approvedBudget.length === 0
                  ? "No budget lines available. Please ensure the project has an approved budget."
                  : "Select budget line"
              }
              notFoundContent={
                approvedBudget.length === 0 && !approvedBudgetLoading
                  ? "No budget lines found. Please ensure the project has an approved budget."
                  : "No budget lines found"
              }
            >
              {approvedBudget.map((budgetline) => (
                <Option key={budgetline.id} value={budgetline.id}>
                  {budgetline.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {showConceptNotes && (
            <AppInput
              name="activity_concept_note_id"
              label="Activity Concept Note"
              type="select"
              rules={[
                { required: true, message: "Please select a concept note" },
              ]}
              options={map(
                projectsDetails?.approvedProjectConceptNotes,
                (activityConceptNote) => ({
                  value: activityConceptNote.id,
                  label: `${moment(activityConceptNote?.date).format(
                    "DD/MM/YYYY"
                  )}  ${activityConceptNote.title}`,
                })
              )}
            />
          )}

          <Form.Item
            name="type"
            label="Type"
            rules={[{ required: true, message: "Please select a budget line" }]}
          >
            <Select loading={approvedBudgetLoading} allowClear>
              {appConfig.requisitionMemoTypes.map((type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please add details" }]}
            name="details"
            label="Details"
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item className={"mt-3"} wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              loading={addRequisitionMemosLoading}
              htmlType="submit"
              type="primary"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddRequsitionMemo;
